import { Injectable } from "@angular/core";
import { idField, ReferenceField } from "@common/references/reference-field";
import { User } from "./users.interfaces";
import { DefaultService } from "@common/references/default.service";
import { delay, Observable } from "rxjs";
import { PageResult } from "@shared/components/classes/page-result";
import { map } from "rxjs/operators";
import urlJoin from "url-join";
import { environment } from "@environments/environment";
import { UserFormComponent } from '@modules/settings/users/user-form/user-form.component';

@Injectable({
  providedIn: "root",
})
export class TaxesService extends DefaultService<User> {
  backendName = 'taxes';
  formComponent = UserFormComponent;

  title = 'MENU.TAXES';
  titleSingular = 'TAX';
  fields: ReferenceField[] = [
    idField,
    {fieldName: 'firstName', label: 'USERS.FIRSTNAME'},
    {fieldName: 'lastName', label: 'USERS.LASTNAME'},
    {fieldName: 'username', label: 'USERS.USERNAME'},
    {fieldName: 'role', label: 'USERS.ROLE'},
    {fieldName: 'email', label: 'USERS.EMAIL'},
    {fieldName: 'phoneNumber', label: 'USERS.PHONENUMBER'},
    {fieldName: 'status', label: 'USERS.STATUS', viewType: 'status'},
  ];
  hasActions = true;
  hasAdd = true;
  hasDelete = true;

  getUrl(): string {
    return urlJoin(environment.apiUrl, 'v1/taxes');
  }
}
